import * as React from "react";
import { Box, Link as MaterialLink, Tooltip, useTheme } from "@material-ui/core";
import NavigateIcon from "../../assets/icons/NavigateIcon";
import { Link } from "react-router-dom";

type SimpleLinkProps = {
  href: string;
  label: string;
  tooltip?: string;
  backIcon?: boolean;
};

function SimpleLink({ href, label, tooltip = "", backIcon = false }: SimpleLinkProps) {
  const theme = useTheme();

  return (
    <Tooltip title={tooltip}>
      <Link style={{ textDecoration: "none" }} to={href}>
        <MaterialLink component="div">
          <Box
            alignItems="center"
            flex="auto"
            justifyContent="center"
            display="flex"
            color={backIcon ? theme.customPalette.text.primary : theme.palette.primary.main}
          >
            {backIcon ? (
              <>
                <NavigateIcon transform="rotate(-180)" /> <strong>{label}</strong>
              </>
            ) : (
              <>
                <strong>{label}</strong> <NavigateIcon />
              </>
            )}
          </Box>
        </MaterialLink>
      </Link>
    </Tooltip>
  );
}

export default SimpleLink;
